import type { ToolCallMessagePartProps } from "@assistant-ui/react";
import { GenUIComponentNotSupported } from "./GenUIComponentNotSupported";
import { genUIRegistry } from "./registry";

/**
 * Renders a GenUI rich component from a `genui` tool-call part (see `transport.ts`). Dispatches
 * on `args.component`; falls back to <GenUIComponentNotSupported /> when no renderer is registered.
 */
export function GenUIComponentRegistry({ args }: ToolCallMessagePartProps) {
  const component = typeof args?.component === "string" ? args.component : "";
  const props = (args?.props ?? {}) as Record<string, unknown>;
  const renderer = genUIRegistry[component];

  if (!renderer) {
    return <GenUIComponentNotSupported component={component} />;
  }

  return <>{renderer(props)}</>;
}
